(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;

  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

  const sectionProgress = (element) => {
    const rect = element.getBoundingClientRect();
    const travel = Math.max(1, rect.height - window.innerHeight);
    return clamp(-rect.top / travel);
  };

  const updateScenes = () => {
    frame = 0;
    if (reduceMotion.matches || root.dataset.kvMotion === 'paused') return;

    document.querySelectorAll('[data-kv-cinematic], [data-kv-hero], [data-kv-private-gallery]').forEach((scene) => {
      scene.style.setProperty('--kv-progress', sectionProgress(scene).toFixed(4));
    });

    document.querySelectorAll('[data-kv-parallax], [data-kv-depth]').forEach((element) => {
      const rect = element.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const viewportCenter = window.innerHeight / 2;
      const value = clamp((center - viewportCenter) / window.innerHeight, -1, 1);
      element.style.setProperty('--kv-parallax', value.toFixed(4));
      element.style.setProperty('--kv-depth-y', `${(value * -16).toFixed(2)}px`);
      element.style.setProperty('--kv-private-lift', `${(value * -12).toFixed(2)}px`);
    });

    document.body.classList.toggle('kv-header-compact', window.scrollY > 24);
  };

  const requestUpdate = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(updateScenes);
  };

  const reveal = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        reveal.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-kv-reveal]:not(.is-observed)').forEach((element) => {
      element.classList.add('is-observed');
      if (reduceMotion.matches) element.classList.add('is-visible');
      else reveal.observe(element);
    });

    scope.querySelectorAll('[data-kv-skip]').forEach((button) => {
      if (button.dataset.kvBound) return;
      button.dataset.kvBound = 'true';
      button.addEventListener('click', () => {
        const target = document.querySelector(button.getAttribute('href'));
        if (target) target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
    });

    scope.querySelectorAll('[data-kv-motion-toggle]').forEach((button) => {
      if (button.dataset.kvBound) return;
      button.dataset.kvBound = 'true';
      const refresh = () => {
        const paused = root.dataset.kvMotion === 'paused';
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('[data-kv-motion-label]')?.replaceChildren(document.createTextNode(paused ? 'Play motion' : 'Pause motion'));
      };
      button.addEventListener('click', () => {
        const paused = root.dataset.kvMotion === 'paused';
        root.dataset.kvMotion = paused ? 'playing' : 'paused';
        try { localStorage.setItem('kv-motion', root.dataset.kvMotion); } catch (_) {}
        refresh();
        requestUpdate();
      });
      refresh();
    });

    requestUpdate();
  };

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const conserveData = Boolean(connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || ''));

  try { root.dataset.kvMotion = conserveData ? 'paused' : (localStorage.getItem('kv-motion') || 'playing'); }
  catch (_) { root.dataset.kvMotion = 'playing'; }

  root.classList.remove('no-js');
  root.classList.add('js', 'kv-ready');
  initialise();

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  reduceMotion.addEventListener?.('change', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
